import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { AppSerialized } from '@playq/octopus2-apps';
import type { PermsSerialized, Perms } from '@playq/octopus2-auth';

import { getUrlAppName } from '/helpers';

import { systemRehydrate } from '../../systemActions';

import { IAppSelectPayload, initialAppState } from './state';
import { appSelectors, baseSelectors } from './selectors';

export const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    updateApp: (state, { payload }: PayloadAction<AppSerialized>) => {
      state.app = payload;
    },
    updatePerms: (state, { payload }: PayloadAction<Perms>) => {
      state.perms = payload.serialize();
    },
    resetApp: () => initialAppState,
    failure: (state, { payload }: PayloadAction<string>) => {
      state.error = payload;
      state.pending = false;
    },
    updateAccess: (state, { payload }: PayloadAction<{ app: AppSerialized; perms: PermsSerialized }>) => {
      const { app, perms } = payload;
      state.app = app;
      state.perms = perms;
      state.error = undefined;
      state.pending = false;
    },
    startAppSelecting: (state, { payload }: PayloadAction<IAppSelectPayload>) => {
      state.app = payload.app;
      state.pending = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase('auth/login/pending', (state) => {
        const isApp = !!getUrlAppName(window.location.pathname);
        state.pending = isApp;
      })
      .addCase(systemRehydrate, (state) => {
        const isApp = !!getUrlAppName(window.location.pathname);
        state.pending = isApp;
      });
  },
});

export const appToolkit = Object.freeze({
  initialState: initialAppState,
  actions: appSlice.actions,
  selectors: {
    ...baseSelectors,
    ...appSelectors,
  },
});

export const appReducer = appSlice.reducer;
